/**
 * Custom hook per ottenere un singolo item da una tabella DynamoDB tramite chiave primaria.
 * @template T Tipo dell'item restituito
 * @template K Chiavi dell'item usate per la ricerca
 * @param {string} table - Nome della tabella DynamoDB
 * @param {Pick<T, K>} key - Oggetto chiave (pk, sk, ecc.)
 * @param {boolean} [enabled=true] - Se la query deve essere abilitata
 * @returns {ReturnType<typeof useDynamoGetItem<T>>} Risultato della query (dati, stato, errori)
 */
import { useMemo } from "react";
import { useDynamoGetItem } from "../../services/dynamo";

export function useGetItem<T, K extends keyof T = keyof T>(
  table: string,
  key: Pick<T, K>,
  enabled: boolean = true,
) {
  const command = useMemo(
    () =>
      ({
        TableName: table,
        Key: key,
      }) as const,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [table, ...Object.entries(key).map(([k, v]) => `${k}:${v}`)],
  );
  return useDynamoGetItem<T>(command, { enabled });
}
